@if (activities().length === 0) {
  <div class="flex h-full w-full items-center justify-center text-proffeo-muted">
    <p>{{ 'project-tasks.details.no-data.activities' | translate }}</p>
  </div>
} @else {
  <div class="flex h-full w-full flex-col gap-1.5">
    @for (row of timelineRows(); track row.id) {
      @switch (row.type) {
        @case ('date') {
          <div class="flex w-full items-center justify-between">
            <span class="flex-10 h-[1px] bg-proffeo-surface-subtle"></span>
            <span class="px-4 timeline-date my-2 text-sm opacity-75">
              {{ row.date | proffeoDate }}
            </span>
            <span class="flex-11 h-[1px] bg-proffeo-surface-subtle"></span>
          </div>
        }
        @case ('activity') {
          <proffeo-task-activity [groupedTaskActivities]="row.activities"></proffeo-task-activity>
        }
      }
    }
  </div>
}
